module.exports = __webpack_public_path__ + "img/cindy-chen-EP4VrAn-WaY-unsplash.9770e46c.jpg";